import styled from "styled-components";

export const GamificationCardContainer = styled.div`
  display: flex;
  padding: 1rem;
  align-items: center;
  gap: 1rem;
  width: fit-content;

  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.groups.gamification.cardBorder};
  background: ${({ theme }) => theme.groups.gamification.cardBackground};

  @media screen and (max-width: 1366px) {
    h1,
    h2,
    h3,
    h4,
    p {
      font-size: 0.813rem !important;
    }
  }
`;
